import React from 'react'
import {KTSVG} from 'helpers'

type FestiveTemplate = {
 language_code: string
 template_text: string
}

type Props = {
 imageUrl?: string
 festivalName?: string
 fpoName?: string
 address?: string
 phone?: string
 selectedTemplate?: FestiveTemplate | null
}

const FestiveImageSection = ({
 imageUrl,
 festivalName,
 fpoName,
 address,
 phone,
 selectedTemplate,
}: Props) => {
 return (
  <div className='flex justify-center'>
   <div
    className='relative w-[260px] bg-white rounded-md overflow-hidden shadow-sm'
    style={{backgroundColor: '#F2F2F2', padding: '8px'}}
   >
    <div
     className='relative w-full aspect-[3/4]'
     style={{borderRadius: '8px', overflow: 'hidden'}}
    >
     {imageUrl && (
      <img
       src={imageUrl}
       alt='festive'
       className='absolute inset-0 w-full h-full object-cover'
      />
     )}

     <div className='absolute inset-0 flex flex-col items-center text-center px-4 pt-8'>
      <KTSVG
       path='/media/icons/bayer.svg'
       svgClassName='w-[38px] h-[38px] mb-3'
      />

      <p className='text-[#8B2E00] text-[13px] font-medium'>
       {selectedTemplate?.template_text}
      </p>

      <p className='text-[#E8590C] text-[18px] font-bold mt-3'>
       {festivalName}
      </p>
     </div>
    </div>

    <div className='bg-white text-center py-3 px-4 border-t'>
     <p className='font-semibold text-[#1C4E80] text-[14px]'>
      {fpoName}
     </p>
     <p className='text-[12px] text-gray-600'>{address}</p>
     <p className='text-[13px] text-[#1C4E80] font-medium mt-1'>
      {phone}
     </p>
    </div>
   </div>
  </div>
 )
}

export default FestiveImageSection
